module.exports = __webpack_public_path__ + "static/img/h2-1.7b23008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h2-1.png
// module id = HOXm
// module chunks = 1